import React, { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { KeyRound } from "lucide-react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { db } from "@/api/base44Client";
import { AdminStatTiles } from "@/components/admin/AdminStatTiles";
import { AdminListPanel } from "@/components/admin/AdminListPanel";
import { AiGeneratorPanel } from "@/components/admin/AiGeneratorPanel";
import { JsonImportPanel } from "@/components/admin/JsonImportPanel";
import { QuestionDatabase } from "@/components/admin/QuestionDatabase";
import { CoverageOverview } from "@/components/admin/CoverageOverview";
import "@/components/admin/admin.css";

export default function Admin() {
  const { user } = useAuth();
  if (user && user.role !== "admin") return <Navigate to="/faecher" replace />;
  return <AdminDashboard />;
}

function AdminDashboard() {
  const qc = useQueryClient();
  const [view, setView] = useState(null);
  const { data: stats } = useQuery({ queryKey: ["admin-stats"], queryFn: db.admin.stats });
  const { data: users = [] } = useQuery({ queryKey: ["admin-users"], queryFn: db.admin.listUsers });
  const { data: licenses = [] } = useQuery({ queryKey: ["admin-licenses"], queryFn: db.admin.listLicenses });

  const refreshAdmin = () => ["admin-stats", "admin-users", "admin-licenses"].forEach((k) => qc.invalidateQueries({ queryKey: [k] }));
  const refreshQuestions = () => { qc.invalidateQueries({ queryKey: ["admin-questions"] }); qc.invalidateQueries({ queryKey: ["questions"] }); };

  return (
    <div className="adm" data-testid="admin-dashboard">
      <header className="adm-head">
        <div>
          <span className="adm-eyebrow"><KeyRound className="h-3.5 w-3.5" /> ADMIN-BEREICH</span>
          <h1 className="adm-title">Admin-Dashboard</h1>
          <p className="adm-sub">Nutzer, Lizenzcodes und Fragen an einem Ort verwalten.</p>
        </div>
      </header>

      <AdminStatTiles stats={stats} active={view} onSelect={setView} />
      <AdminListPanel view={view} users={users} licenses={licenses} onChange={refreshAdmin} />

      <CoverageOverview />
      <AiGeneratorPanel onGenerated={refreshQuestions} />
      <JsonImportPanel onImported={refreshQuestions} />
      <QuestionDatabase />
    </div>
  );
}
